const CIRCLE_POINT = (layerId, sourceId, paintData = {}) => {
  const {
    radius = 9, color = '#308DFF', borderWidth = 1, borderColor = '#fff',
  } = paintData;

  const paint = {
    'circle-color': color,
    'circle-radius': radius,
    'circle-stroke-width': borderWidth,
    'circle-stroke-color': borderColor,
  };

  return {
    id: layerId,
    type: 'circle',
    paint,
    source: sourceId,
    layout: {},
  };
};

export default CIRCLE_POINT;
